import * as intl from './intlPolyfill';

export const polyfill = async () => {
    await intl.polyfill();
};
